import React, { useState } from 'react';
import CheckoutHotelRoom from './CheckoutHotelRoom';

export default function CheckoutHotelRoomSelectionRoom({
  scope,
  possibility,
  selectedPossibilityIndex,
  handleSelect,
  // Called instead of `handleSelect` when a bed configuration is picked. A
  // validated room re-beds itself through it while leaving `handleSelect` —
  // which the card and its variants also call — inert.
  onChangeBed,
  isSelected,
  isRoomSelected,
  filters,
  testId,
  selectedRoom,
  children,
}) {
  const [pickedBedIndex, setPickedBedIndex] = useState(0);

  const currentPossibility =
    selectedPossibilityIndex === undefined
      ? possibility
      : (possibility?.variants?.find(
          (variant) => variant.originalIndex === selectedPossibilityIndex,
        ) ?? possibility);

  // The configurations offered depend on the slot being filled (KD-3732), so a
  // bed picked for one slot may no longer exist in the next one's shorter list:
  // the card then falls back to its first configuration.
  const currentBedIndex =
    pickedBedIndex < (currentPossibility?.bedChoices?.length ?? 0)
      ? pickedBedIndex
      : 0;

  const currentBed =
    possibility?.bed ?? currentPossibility?.bedChoices[currentBedIndex];

  const travelersCount = Math.max(
    filters?.rooms?.reduce((acc, room) => acc + room.adults + room.children, 0),
    1,
  );

  // The room-selection modal shows no summary beside the list, so the card is
  // the only price the user gets: it quotes what the room will actually cost,
  // ticked supplements included. Both come from the room the selection holds —
  // `selectedRoom` while it is being chosen, `possibility.bed` once validated —
  // since a promotion is picked on a DIFFERENT possibility of the same hotel
  // room, one this card's own `possibility` never becomes. The rooms that are
  // merely offered fall back to the price the availability quotes.
  const total =
    (selectedRoom ?? possibility)?.bed?.totalPriceWithPromo ??
    currentBed?.totalPriceWithPromo ??
    0;

  return (
    <CheckoutHotelRoom
      scope={scope}
      room={currentPossibility}
      parentRoom={possibility}
      selectedRoomIndex={selectedPossibilityIndex}
      currentBed={currentBed}
      price={{
        total,
        currency:
          (selectedRoom ?? possibility)?.bed?.currency ??
          currentBed?.currency ??
          currentPossibility?.bedChoices?.[currentBedIndex]?.currency ??
          possibility?.bedChoices?.[0]?.currency,
        travelersCount,
      }}
      isSelected={isSelected}
      onSelect={(index) => handleSelect(index, currentBedIndex)}
      testId={testId}
    >
      {children &&
        children({
          possibility: currentPossibility,
          currentBed,
          currentBedIndex,
          changeSelectedBed: (bedIndex) => {
            setPickedBedIndex(bedIndex);
            if (onChangeBed) {
              onChangeBed(bedIndex);
            } else {
              handleSelect(possibility?.originalIndex, bedIndex);
            }
          },
          isSelected,
          isRoomSelected,
        })}
    </CheckoutHotelRoom>
  );
}
